import { Input } from '@base-ui/react/input'
import clsx from 'clsx'

export interface DateInputProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {}

export function DateInput({ className, ...props }: DateInputProps) {
  return (
    <Input
      type="date"
      className={clsx(
        // Base styles
        'bg-white border border-gray-stroke h-10 w-full rounded-lg px-4 text-base outline-none transition-colors',
        'focus:ring-0 focus:border-lavender disabled:text-charcoal-50 disabled:cursor-not-allowed',
        'placeholder:text-charcoal-50',
        // Invalid state styling using BaseUI data attributes
        'data-invalid:border-brick-light data-invalid:focus:border-brick-light',
        // Additional classes
        className
      )}
      {...props}
    />
  )
}
